export const widgets = {
  WLivenow: () => import('@/widgets/WLivenow/WLivenow.vue'),
  WHighlights: () => import('@/widgets/WHighlights/WHighlights.vue'),
  WUpcoming: () => import('@/widgets/WUpcoming/WUpcoming.vue'),
  WBannerEvents: () => import('@/widgets/WBannerEvents/WBannerEvents.vue'),
  WBannerBetting: () => import('@/widgets/WBannerBetting/WBannerBetting.vue'),
  WEvent: () => import('@/widgets/WEvent/WEvent.vue')
}
